import { z } from 'zod';

import { createPaginatedResponseSchema } from './pagingSchema.ts';

export const JobTypeSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  description: z.string().nullish().optional(),
  serviceType: z.enum(['Static', 'Mobile']),
  isActive: z.boolean().optional(),
  isSingleItem: z.boolean().optional(),
});

export const JobTypeCreateFERequestSchema = JobTypeSchema.omit({
  id: true,
});

export const JobTypeUpdateFERequestSchema = JobTypeSchema;

export const JobTypeFindFERequestSchema = z.object({
  searchText: z.string(),
  isActive: z.boolean().nullish().optional(),
  pageNumber: z.number(),
  resultsPerPage: z.number(),
});

export const JobTypeFindFEResponseSchema =
  createPaginatedResponseSchema(JobTypeSchema);

export type JobTypeModel = z.infer<typeof JobTypeSchema>;

export type JobTypeCreateFERequestModel = z.infer<
  typeof JobTypeCreateFERequestSchema
>;

export type JobTypeUpdateFERequestModel = z.infer<
  typeof JobTypeUpdateFERequestSchema
>;

export type JobTypeFindFERequestModel = z.infer<
  typeof JobTypeFindFERequestSchema
>;

export type JobTypeFindFEResponseModel = z.infer<
  typeof JobTypeFindFEResponseSchema
>;
